<template>
  <div class="card-content">
    <div class="signin-form row justify-content-center p-0 m-0">
      <form class="form-group col-8 pl-3 pr-3 mt-auto mb-4" @submit.prevent="forgot">
        <div class="mb-4 mt-5">
          <h2 class="m-0 text-primary system-title">Sistema Financeiro</h2>
        </div>

        <div class="mb-3" :class="{ 'has-error': $v.email.$invalid && $v.email.$dirty }">
          <label class="mb-2">Email:</label>
          <input
            id="username"
            v-model="email"
            class="form-control text-center"
            type="text"
            autofocus
            @input="$v.email.$touch()"
          />
          <small v-if="emailIsValid" class="text-danger">E-mail inválido.</small>
        </div>

        <div class="mb-3 text-center">
          <div ref="recaptchaContainer"></div>
          <small v-if="recaptchaError" class="text-danger">
            Confirme o reCAPTCHA antes de enviar.
          </small>
        </div>

        <div class="text-center mb-2">
          <button type="submit" class="btn btn-primary col-sm-12 col-md-6 mt-3 mb-3">
            Enviar E-mail
          </button>
        </div>

        <div class="text-center mb-4">
          <router-link to="/acessar" class="access-account-link">
            Acessar minha conta.
          </router-link>
        </div>
      </form>
    </div>
    <div class="signin-footer row justify-content-center pl-3 pr-3 mb-4" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useVuelidate } from '@vuelidate/core';
import { required, email as emailValidator } from '@vuelidate/validators';
import AccountApi from '@/services/AccountApi';
import Alert from '@/models/Alert';
import { useGlobalPlugins } from '@/composables/useGlobalPlugins';
import { useRecaptcha } from '@/composables/useRecaptcha';

const router = useRouter();
const { $bus, $alert } = useGlobalPlugins();

const email = ref(null);
const { recaptchaContainer, recaptchaError, getRecaptchaToken } = useRecaptcha();

const rules = computed(() => ({
  email: { required, email: emailValidator },
}));

const $v = useVuelidate(rules, { email });

const emailIsValid = computed(() => {
  return $v.value?.email.$invalid && $v.value.email.$dirty;
});

const forgot = async () => {
  $v.value.$touch();
  if ($v.value.$invalid) {
    return;
  }

  const recaptchaToken = getRecaptchaToken();
  if (recaptchaError.value) {
    return;
  }

  const api = new AccountApi();
  $bus.emit('spinner-run');
  const response = await api.sendPasswordResetEmail(email.value);
  $bus.emit('spinner-stop');

  if (response.status === 422) {
    const alert = new Alert();
    alert.title = 'Ops';
    alert.error = response.data.error;
    alert.confirmButtonText = 'OK';
    $bus.emit('alert-error', alert);
    return;
  }

  $alert.info('Pronto', 'Link enviado com sucesso!');
  router.push('/acessar');
};
</script>

<style scoped>
.system-title {
  font-weight: 900 !important;
  font-size: 2.5rem !important;
  letter-spacing: -0.5px;
}

.access-account-link {
  text-decoration: none !important;
  color: var(--bs-primary, #ff7a00);
  font-weight: 600;
}

.access-account-link:hover {
  text-decoration: none !important;
  color: var(--bs-primary-dark, #e56900);
}
</style>
